import React from 'react';
import AltIso from 'alt/utils/AltIso';
import imgResolver from '../utils/img-resolver';

import SeoActions from '../actions/SeoActions';

import withRouter from '../utils/with-router';
import doRedirect from '../utils/doRedirect';

@AltIso.define((props) => {
    return Promise.all([
        new Promise((resolve) => {
            SeoActions.pushTitle('Profile Completed');
            resolve();
        })
    ]);
})

@withRouter
class CompleteProfileCompleted extends React.Component {

    componentWillReceiveProps() {
        if (this.props.user.profile.profile.is_candidate) {
            doRedirect(this.context.router, 'offers');
        }
    }

    redirectToOffers() {
        // Need to fully reload the page to get proper and new user data - Kevin
        window.location = '/offers/';
    }

    render() {
        return (
            <div className="view-shift-completed">
                <div className="bg-img"></div>
                <div className="view-content maxwidth-wrapper">
                    <img className="" src={require('../styles/images/vasterbotten-at-night.png')} alt="" />

                    <h1>Done! Your profile is now complete!</h1>

                    <div className="buttons">
                        <a onClick={this.redirectToOffers.bind(this)} className="btn btn-green">View job offers</a>
                    </div>
                </div>
            </div>
        );
    }
}
export default CompleteProfileCompleted;



/** WEBPACK FOOTER **
 ** ./app/src/views/CompleteProfileCompleted.js
 **/